import { jsx as _jsx } from "react/jsx-runtime";
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';
import RemoveModeratorOutlinedIcon from '@mui/icons-material/RemoveModeratorOutlined';
import GppMaybeOutlinedIcon from '@mui/icons-material/GppMaybeOutlined';
export function getIconForViolationStatus(violationStatus) {
    let icon;
    switch (violationStatus) {
        case 'NV':
            icon = _jsx(VerifiedUserOutlinedIcon, { color: "success" });
            break;
        case 'V':
            icon = _jsx(RemoveModeratorOutlinedIcon, { color: "error" });
            break;
        default:
            icon = _jsx(GppMaybeOutlinedIcon, { color: "error" });
            break;
    }
    return icon;
}
